export default __webpack_public_path__ + "static/media/icon-arrow-back-color-gray-dark.59aacba3.svg";